<p-dialog
  data-testid="alert-reason-dialog"
  [visible]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '90vw', maxWidth: '600px' }"
  [header]="getDialogTitle()"
  (onHide)="onCancel()"
>
  <!-- Dialog Message -->
  <div class="mb-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
    <div class="flex items-start">
      <i class="pi pi-info-circle text-blue-600 mr-3 mt-1"></i>
      <div>
        <p class="text-blue-700 text-sm">{{ getDialogMessage() }}</p>
      </div>
    </div>
  </div>

  <!-- Reason Form -->
  <form data-testid="alert-reason-dialog-form" [formGroup]="reasonForm" class="reason-form">
    <div class="form-field">
      <label for="reason" class="block text-sm font-medium text-gray-700 mb-2">
        {{ "stock_alert.dialog.reason_label" | translate }}
        <span class="text-red-500">*</span>
      </label>
      <textarea
        data-testid="alert-reason-dialog-reason-input"
        id="reason"
        formControlName="reason"
        pTextarea
        [rows]="5"
        [autoResize]="true"
        [placeholder]="'stock_alert.dialog.reason_placeholder' | translate"
        class="w-full"
        [class.ng-invalid]="
          reasonForm.get('reason')?.invalid && reasonForm.get('reason')?.touched
        "
      ></textarea>
      @if (
        reasonForm.get("reason")?.invalid &&
        (reasonForm.get("reason")?.touched || reasonForm.get("reason")?.dirty)
      ) {
        <small class="text-red-500 text-xs mt-1 block">
          {{ getReasonError() }}
        </small>
      }
      <small class="text-gray-500 text-xs mt-1 block">
        {{ "stock_alert.dialog.reason_hint" | translate: { max: 500 } }}
      </small>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <app-button
        [testId]="'alert-reason-dialog-cancel-btn'"
        [label]="'common.actions.cancel' | translate"
        type="secondary"
        [outlined]="true"
        (emitOnClick)="onCancel()"
      ></app-button>
      <app-button
        [testId]="'alert-reason-dialog-confirm-btn'"
        [label]="'common.actions.confirm' | translate"
        type="info"
        (emitOnClick)="onConfirm()"
        [disabled]="reasonForm.invalid"
      ></app-button>
    </div>
  </ng-template>
</p-dialog>
